import { render, staticRenderFns } from "./StarIntegrationContent.vue?vue&type=template&id=b5b82fd8"
import script from "./StarIntegrationContent.vue?vue&type=script&lang=js"
export * from "./StarIntegrationContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports